import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {
  defineMessages,
  FormattedMessage,
  injectIntl,
  intlShape
} from 'react-intl';
import { get } from 'lodash';
import RouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Alert, Button, Input, InputGroup } from 'reactstrap';
import { Link } from 'react-router-dom';

import { modelOf } from '../../../prop-types';
import PageTitle from '../../common/PageTitle';
import SEOTitle from '../../head/SEOTitle';
import AddressStore from '../../../store/AddressStore';
import ContentForState from '../../loader/ContentForState';
import AddressList from '../../address/AddressList';
import generatePath from '../../../util/generatePath';
import Paths from '../../../types/Paths';
import UnexpectedError from '../../loader/UnexpectedError';
import globalTranslations from '../../../i18n/globalTranslations';
import RouteService from '../../../services/RouteService';
import HelperNavigation from '../../common/HelperNavigation';
import AccountStore from '../../../store/AccountStore';

const messages = defineMessages({
  addressFilterPlaceholder: {
    id: 'address.addressFilterPlaceholder',
    defaultMessage: 'Search for addresses'
  }
});

@observer
export class MyAccountAddressList extends Component {
  state = {
    removeError: null,
    requestId: 0,
    addressFilterString: ''
  };

  componentDidMount() {
    const { addressStore } = this.props;
    addressStore.loadAddresses();
  }

  setAddressFilterString = (newString) => {
    this.setState(() => ({
      addressFilterString: newString
    }));
  };

  getBreadcrumbsPath = () => {
    const { intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: Paths.MyAccount
      },
      {
        text: intl.formatMessage(globalTranslations.addressBookTitle),
        url: Paths.MyAccountAddressList
      }
    ]);
  };

  removeAddress = (addressId) => {
    const { addressStore } = this.props;
    addressStore
      .removeAddress(addressId)
      .then(() => {
        addressStore.loadAddresses();
        this.setState({ removeError: null });
      })
      .catch((error) =>
        this.setState({
          removeError: error,
          requestId: this.state.requestId + 1
        })
      );
  };

  navigateToAddress = (addressId) => {
    const { routeService } = this.props;
    const path = routeService.getPath(
      generatePath(Paths.MyAccountAddress, { id: addressId })
    );
    return this.props.history.push(path);
  };

  renderAddressList = () => {
    const { addressStore } = this.props;
    return (
      <AddressList
        addresses={addressStore.addressArray}
        onEditClick={this.navigateToAddress}
        onRemoveClick={this.removeAddress}
        filterString={this.state.addressFilterString}
      />
    );
  };

  renderError = () => {
    const { removeError, requestId } = this.state;
    const errors = get(removeError, 'response.data.errors');
    return errors ? (
      <Alert
        className="MyAccountAddressList__errors"
        color="danger"
        key={requestId}
      >
        {Object.values(removeError.response.data.errors).map((message) => (
          <div key={message}>{message}</div>
        ))}
      </Alert>
    ) : (
      <UnexpectedError />
    );
  };

  render() {
    const { addressStore, routeService, intl, accountStore } = this.props;
    const { removeError } = this.state;
    return (
      <div className="MyAccountAddressList">
        <SEOTitle title={globalTranslations.addressBookTitle} />
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <PageTitle>
          <FormattedMessage {...globalTranslations.addressBookTitle} />
        </PageTitle>
        <div className="MyAccountAddressList__tools">
          {(accountStore.isUserAllowedAddressModification ||
            !accountStore.isCustomerUser) && (
            <div className="MyAccountAddressList__tools-add-new">
              <Link to={routeService.getPath(Paths.MyAccountAddressNew)}>
                <Button
                  color="primary"
                  className="MyAccountAddressList__tools-add-new-button"
                >
                  <FormattedMessage
                    {...globalTranslations.addNewAddressTitle}
                  />
                </Button>
              </Link>
            </div>
          )}
          <div className="MyAccountAddressList__tools-filter">
            <InputGroup className="MyAccountAddressList__tools-filter-group btn-group">
              <Input
                value={this.state.addressFilterString}
                onChange={(e) => this.setAddressFilterString(e.target.value)}
                placeholder={intl.formatMessage(
                  messages.addressFilterPlaceholder
                )}
              />
              <Button
                onClick={() => this.setAddressFilterString('')}
                className="MyAccountAddressList__tools-filter-button"
                block
              >
                <FormattedMessage {...globalTranslations.clearTitle} />
              </Button>
            </InputGroup>
          </div>
        </div>
        {removeError && this.renderError()}
        <ContentForState
          state={addressStore.state}
          error={addressStore.lastError}
          forLoaded={() => this.renderAddressList()}
        />
      </div>
    );
  }
}

MyAccountAddressList.propTypes = {
  addressStore: modelOf(AddressStore).isRequired,
  history: RouterPropTypes.history.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  intl: intlShape.isRequired,
  accountStore: modelOf(AccountStore).isRequired
};

export default injectIntl(
  inject('addressStore', 'routeService', 'accountStore')(
    withRouter(MyAccountAddressList)
  )
);



// WEBPACK FOOTER //
// ./src/components/my-account/MyAccountAddressList/index.jsx